<div class="layout-footer p-ac-between">


 <!--    <img src="assets/layout/images/{{layoutService.config.colorScheme === 'light' ? 'logo-dark' : 'logo-white'}}.svg" alt="Logo" height="20" class="mr-2"/>
    by
    <span class="font-medium ml-2">PrimeNG</span> -->

    <div class="grid w-full justify-content-between">
        <div class="col-12 md:col-6 lg:col-3 py-2 font-medium">2022 © GeoPerform | Version 2.0</div>
        <div class="col-12 md:col-6 lg:col-3 text-right py-2 font-medium">Now:26 July 06:00 UTC</div>
       
    </div>
        

</div>
